/* Fix variant button onclick handlers broken by | json filter in HTML attributes */
document.addEventListener('DOMContentLoaded', function() {
  var colorName = (window.IB_COLOR_OPTS || [])[0] || 'Couleur';

  document.querySelectorAll('.ib-cb').forEach(function(btn) {
    btn.removeAttribute('onclick');
    btn.addEventListener('click', function() {
      var val = btn.getAttribute('title');
      if (val) ibSEL(btn, colorName, val, 'cb');
    });
  });

  document.querySelectorAll('.ib-co').forEach(function(btn) {
    btn.removeAttribute('onclick');
    btn.addEventListener('click', function() {
      var span = btn.querySelector('.ib-sb-c');
      var val = span ? span.textContent.trim() : null;
      if (val) ibSEL(btn, colorName, val, 'co');
    });
  });

  document.querySelectorAll('.ib-sb[data-opt-name]').forEach(function(btn) {
    btn.removeAttribute('onclick');
    btn.addEventListener('click', function() {
      var n = btn.dataset.optName, v = btn.dataset.optVal;
      if (n && v) ibSEL(btn, n, v, 'sb');
    });
  });

  document.querySelectorAll('.ib-nb[data-opt-name]').forEach(function(btn) {
    btn.removeAttribute('onclick');
    btn.addEventListener('click', function() {
      var n = btn.dataset.optName, v = btn.dataset.optVal;
      if (n && v) ibSEL(btn, n, v, 'nb');
    });
  });
});
